const styles = theme => ({
  filtersModal: {
    height: '90vh',
    maxHeight: '90vh',
    width: '65vw',
    maxWidth: '1000px',
    padding: '0',
    borderRadius: '0px',
    display: 'flex',
    flexDirection: 'column',
    alignItems: 'flex-start',
    justifyContent: 'flex-start',

    [theme.breakpoints.down('sm')]: {
      height: '100vh',
      maxHeight: '100vh',
      width: '100vw',
      maxWidth: '100vw',
      boxShadow: 'none',
      borderRadius: '0',
    },
  },
  paddingIOS: {
    padding: '30px 0px',
  },
  titleContainer: {
    width: '100%',
    display: 'flex',
    alignItems: 'center',
    justifyContent: 'space-between',
    borderBottom: `1px solid ${theme.palette.primary.borderColor}`,
    gap: '10px',
    padding: '16px',

    [theme.breakpoints.down('sm')]: {
      padding: '24px 16px 16px 16px',
    },
  },

  title: {
    color: theme.palette.primary.adgmBlack,
    fontWeight: '600',
    fontSize: '16px',
    lineHeight: '150%',
  },

  closeBtn: {
    minHeight: 'auto',
    minWidth: 'auto',
    background: 'transparent',
    border: '0 !important',
    padding: '5px !important',
    boxShadow: 'none !important',
    borderRadius: '50%',
  },

  filtersList: {
    width: '100%',
    flex: '1',
    padding: '0 16px',
    overflowY: 'auto',

    [theme.breakpoints.up('sm')]: {
      '& > $filterContainer:not(:last-child)': {
        borderBottom: `1px solid ${theme.palette.primary.borderColor}`,
      },
    },
  },

  propertyFiltersWrapper: {
    width: '100%',
    padding: '16px 0',
    borderBottom: `1px solid ${theme.palette.primary.borderColor}`,
    display: 'none',
    [theme.breakpoints.down('sm')]: {
      display: 'block',
    },
  },

  filterContainer: {
    display: 'flex',
    alignItems: 'flex-start',
    gap: '16px',
    padding: '16px 0',

    '& > $filter': {
      flex: '1',
      maxWidth: 'calc(50% - 8px)',
    },

    [theme.breakpoints.down('sm')]: {
      flexDirection: 'column',
      padding: '0',
      borderBottom: '0',
      gap: '0',

      '& > $filter': {
        width: '100%',
        maxWidth: '100%',
        padding: '16px 0',
      },

      '& > $filter:not(:last-child) ': {
        borderBottom: `1px solid ${theme.palette.primary.borderColor}`,
      },
    },
  },

  filter: {},

  fullWidthFilter: {
    width: '100% !important',
    minWidth: '100% !important',
    maxWidth: '100% !important',
  },

  filtersModalFooter: {
    width: '100%',
    display: 'flex',
    flexDirection: 'row',
    alignItems: 'center',
    justifyContent: 'space-between',
    gap: '16px',
    padding: '16px',
    borderTop: `1px solid ${theme.palette.primary.borderColor}`,
  },

  resetBtn: {
    minHeight: 'auto',
    minWidth: 'auto',
    background: 'transparent !important',
    color: theme.palette.primary.main,
    fontWeight: '400',
    fontSize: '14px',
    lineHeight: '150%',
    textTransform: 'lowercase',
    border: '0 !important',
    boxShadow: 'none !important',
    padding: '10px',
    whiteSpace: 'noWrap',

    '& .MuiButton-label span::first-letter': {
      textTransform: 'uppercase',
    },
  },

  searchBtn: {
    minHeight: 'auto',
    minWidth: 'auto',
    background: '#0088FF',
    color: theme.palette.primary.white,
    fontWeight: '500',
    fontSize: '14px',
    lineHeight: '21px',
    textTransform: 'lowercase',
    padding: '13px 77px',
    borderRadius: '0px',
    boxShadow: 'none',
    whiteSpace: 'noWrap',

    '&:hover': {
      background: '#0088FF',
      color: theme.palette.primary.white,
    },

    '& .MuiButton-label span::first-letter': {
      textTransform: 'uppercase',
    },

    [theme.breakpoints.down('sm')]: {
      padding: '12px 30px',
    },
  },
});

export default styles;
